// Use require instead of import, and order matters
require("./notification.css");

export const Notification = ({ message, variant }) => {
  return (
    <div className={`wallet-notification wallet-notification-${variant}`}>
      {message}
    </div>
  );
};
